import React, {memo} from 'react';
import classNames from 'classnames';

const Icon = (props) => {
  const {
    // affect outter <i>...</i>
    className,
    // affect inner <svg>...</svg>
    type,
    tabIndex,
    onClick,
    ...restProps
  } = props;

  const classString = classNames(
    {
      [`anticon`]: true,
      [`anticon-${type}`]: Boolean(type),
    },
    className,
  );

  let iconTabIndex = tabIndex;
  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }
  return (
    <i
      {...restProps}
      tabIndex={iconTabIndex}
      onClick={onClick}
      className={classString}
    />
  );
};

export default memo(Icon);
